'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { SimpleBlock } from '../SimpleBlock';
import { attachSubComponents } from '../../util';
import { Heading } from './Heading';
import { Detail } from './Detail';
import { Hours, HoursRow } from './Hours';
import { ActionGroup } from './ActionGroup';
import { StoreBlockContext } from './StoreBlockContext';
export const StoreBlock = attachSubComponents('StoreBlock', ({
  children,
  size = 'lg',
  ...props
}) => /*#__PURE__*/React.createElement(StoreBlockContext.Provider, {
  value: {
    size
  }
}, /*#__PURE__*/React.createElement(SimpleBlock, _extends({}, props, {
  "data-aui": "store-block"
}), children)), {
  Map: SimpleBlock.Image,
  Heading,
  Detail,
  ActionGroup,
  Hours,
  HoursRow
});